/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon24Solid = forwardRef('MediaUiAPlayForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m10.74 4.18 10.256 6.285a1.8 1.8 0 0 1 0 3.07L10.741 19.82C9.54 20.555 8 19.692 8 18.286V5.714c0-1.406 1.541-2.27 2.74-1.534Z" }),
        React.createElement("path", { d: "M4.5 4A1.5 1.5 0 0 0 3 5.5v13a1.5 1.5 0 1 0 3 0v-13A1.5 1.5 0 0 0 4.5 4Z" })));
});
